/**
* @description
* # name controller --> enabledStudentsListController
* # As Controller --> enabledStudentsList
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class enabledStudentsListController {
	constructor($scope,enabledStudentsServices,ngNotify,UserInfoConstant,$state,$filter,studentsServices,levelsServices) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services = enabledStudentsServices.services
		this.servicesPeriod = enabledStudentsServices.servicesPeriod
		this.studentsServices = studentsServices.services
		this.levelsServices = levelsServices.services
		this.$scope.buttonActions = false
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.$scope.periodSelect = null
		this.$scope.levelSelect = null
		this.studentName = null
		this.detailsEnabled ={
			enableFiltering: true
		}
		
		this.tableInitializeMethod()
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		this.params = {
			concept_id: this.conceptId
		}
		this.getStudents()
		this.getPeriod()
		this.getLevels()
	}

	tableInitializeMethod() {
		this.detailsEnabled.columnDefs = [
			{field: 'studentCode', displayName: 'Cod Estudiante', headerCellClass : 'text-center', },
			{field: 'levelName', displayName: 'Nivel', headerCellClass : 'text-center', },
			{field: 'periodName', displayName: 'Periodo', headerCellClass : 'text-center', },
			{field: 'createdAt', displayName: 'Fecha Habilitación', headerCellClass : 'text-center', },
		]
	}

	getStudents(){
		this.studentsServices.getStudents(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.students = []
				this.studentsList = dataReturn.results;
				for (let i in this.studentsList){
					this.students.push({
						title: (this.studentsList[i].ds_last_name !== null && this.studentsList[i].ds_last_name !== undefined)  ?  this.studentsList[i].ds_name + ' ' + this.studentsList[i].ds_last_name : '',
						id_code: this.studentsList[i].id_code,
						cod: this.studentsList[i].ds_code,
						coreName: this.studentsList[i].core ? this.studentsList[i].core.ds_name : null,
						badges: [
							{
								label: ( (this.studentsList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.studentsList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getPeriod(){
		this.servicesPeriod.getPeriod().$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.periodList = dataReturn.results
				this.periodList.map((period) => {
					if(period.is_current ){
						this.$scope.periodSelect = period.id_code
					}
				})

				this.params.period_id = this.$scope.periodSelect
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getLevels(){
		this.levelsServices.getLevels(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.levelsList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getEnabledStudent(params){
		this.services.getEnabledStudents(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.detailsEnabled.data = this.setAllDataEnabledStudent(dataReturn.results)
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	setAllDataEnabledStudent(enabledStudents) {
		return enabledStudents.map(enabled => {
			return {
				enabledId: enabled.id_code,
				studentCode: (enabled.student.ds_last_name !== null && enabled.student.ds_last_name !== undefined)  ?  enabled.student.ds_name + ' ' + enabled.student.ds_last_name : '',
				studentId: enabled.student.id_code,
				levelName: enabled.level.ds_name,
				levelId: enabled.level.id_code,
				periodName: enabled.period.ano,
				periodId: enabled.period.id_code,
				createdAt: enabled.createdAt			
			}
		})
	}

	selectChanged(periodSelect){
		this.$scope.periodSelect = periodSelect
		this.params.period_id = periodSelect

		if(this.panelConfig){
			this.getEnabledStudent(this.params)
		}
	}

	onClick(item){
		this.getDetailsFunction(item);
		this.panelConfig = true
		this.$scope.buttonActions = true
	}

	getDetailsFunction(params){
		this.studentName = params.title
		this.studentId = params.id_code
		this.params.student_id = params.id_code
		this.params.period_id = this.$scope.periodSelect
		this.getEnabledStudent(this.params)

	}

	edit(){
		this.$scope.editSave = true
		this.$scope.edit = false
		this.$scope.titleList = false
		this.$scope.titleEdit = true
		this.$scope.isDisabled = false
		this.$scope.levelSelect = null
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.panelConfig = false
		this.$scope.buttonActions = false
		this.getDetailsFunction({student_id : this.studentId});
		
	}

	saveEdit(){
		if(this.$scope.levelSelect === null) {
			this.ngNotify.set('Seleccione un Nivel','warn')
			return
		}

		let params  = {
			period_id   : this.$scope.periodSelect,
			user_id : this.user_id,
			concept_id: this.conceptId,
			level_id: this.$scope.levelSelect,
			student_id: this.studentId
		}

		this.services.saveEnabledStudents(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se habilitó correctamente el Estudiante','success')
				this.$scope.levelSelect = null
				this.getEnabledStudent(this.params)

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Existe habilitación de Estudiante para periodo seleccionado','warn');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Existe habilitación de Estudiante para periodo seleccionado','warn');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
enabledStudentsListController.$inject=['$scope', 'enabledStudentsServices', 'ngNotify','UserInfoConstant','$state','$filter', 'studentsServices', 'levelsServices']


// WEBPACK FOOTER //
// ./src/app/admin-panel/enabledStudents/list/enabledStudentsListController.js